export enum Theme {
  LIGHT = 'light-theme',
  DARK = 'dark-theme'
}
